import axios from 'axios';

export const certificadosApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/certificados`,
});